/**
 * @flow
 */

const host = 'https://staging.universe.com';

export default {
  environment: 'staging',
  api: {
    base: `${host}/api/v2`,
    redemptionsHost: 'https://redemptions.staging.universe.com',
    host
  },
  images: {
    url: 'https://images.universe.com/'
  },
  amplitude: {
    id: '6dff3aa1ddb0eedffcc73805cd59a65a'
  },
  googleTagManager: {
    show: false,
    gtmId: ''
  },
  uploadcare: {
    key: '6983c6f19fcba1adfe3d'
  },
  googleMapsApiKey: 'AIzaSyDLogt5ZeROXdhbZQBsxBvPDk4hkooKpGM',
  sentryDSN: 'https://78babe3f3ba14250a947a17ca5657023@sentry.io/184519',
  passbook_pass_id: 'pass.com.uni.tickets.staging',
};



// WEBPACK FOOTER //
// ./config/staging.js